import React from 'react';
import { observer } from 'mobx-react-lite';
import { ReactComponent as EnterIcon } from 'components/icons/enter.svg';
import { useInjection } from 'services/ioc/ioc.react';
import { ServiceTypes } from 'constants/ServiceTypes';
import { BpTaggingStore } from 'stores/Tagging/BpTaggingStore';
import { SessionStore } from 'stores/SessionStore';
import Notes from 'pages/Tagging/components/ScoreBar/Notes/Notes';
import { HotkeyBadge } from 'pages/Tagging/components/HotkeyBadge/HotkeyBadge';
import StoreTagButton from 'pages/Tagging/components/ScoreBar/StoreTagButton/StoreTagButton';
import { BpScoreBarOuter, BpScoreBarWrapper, StoreTagButtonAndHotkeyWrapper, TeamName } from './BpScoreBarStyles';
import { ScoreBarDivider } from 'pages/Tagging/components/ScoreBar/ScoreBarStyles';

const BpScoreBar: React.FC = observer((props) => {
  const taggingStore = useInjection<BpTaggingStore>(ServiceTypes.BpTaggingStore);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);
  const homeTeamName = sessionStore.currentSessionMetadata.homeTeam?.name ?? '';
  const { selectedPlay } = taggingStore;

  const storeTag = () => {
    taggingStore.storeTag();
  };

  const handleOnChangeCallback = (note: string) => {
    if (selectedPlay) {
      selectedPlay.note = note;
      selectedPlay.isChanged = true;
    }
  };

  const isSuccessButton = (): boolean | undefined => {
    return selectedPlay && !selectedPlay.isChanged && selectedPlay.isTagStored;
  };

  return (
    <BpScoreBarOuter>
      <BpScoreBarWrapper>
        <TeamName>{homeTeamName}</TeamName>
        <ScoreBarDivider />
      </BpScoreBarWrapper>
      <Notes
        value={selectedPlay ? selectedPlay.note : ''}
        onChangeCallback={handleOnChangeCallback}
        disabled={!taggingStore.isLivePlaySelected}
        onFocusIn={(): void => taggingStore.disableEnableHotkeys(true)}
        onFocusOut={(): void => taggingStore.disableEnableHotkeys(false)}
      />
      <StoreTagButtonAndHotkeyWrapper>
        <HotkeyBadge hotkey={<EnterIcon />} />
        <StoreTagButton
          intent={isSuccessButton() ? 'secondary' : 'primary'}
          label={isSuccessButton() ? 'Tag Stored' : 'Save Tag'}
          onClickCallback={storeTag}
          onHotkeyPressCallback={storeTag}
          keyCode={13}
          isDisabled={!selectedPlay || !taggingStore.isLivePlaySelected || (!selectedPlay.isChanged && selectedPlay.isValidated)}
        />
      </StoreTagButtonAndHotkeyWrapper>
    </BpScoreBarOuter>
  );
});

export default BpScoreBar;
